import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import Dropzone from 'react-dropzone';
import A11yFontIcon from 'components/A11yFontIcon';
import TextButton from 'components/TextButton';
import ModalCloseIcon from 'resources/icon-modal-close.svg';
import './ImageUpload.css';

class ImageUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      rejectedFilesError: null,
      preview: null,
      previewClass: null,
      onDrag: false
    };
    this.handleDrop = this.handleDrop.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.dropRejected = this.dropRejected.bind(this);
    this.previewLoaded = this.previewLoaded.bind(this);
  }

  componentWillUnmount() {
    if (this.state.preview) {
      window.URL.revokeObjectURL(this.state.preview);
    }
  }

  handleDrop(acceptedFiles) {
    const { handleImageDrop } = this.props;

    if (acceptedFiles.length > 0) {
      const { preview } = acceptedFiles[0];

      handleImageDrop(acceptedFiles[0]);

      this.setState({
        preview,
        disabled: true,
        rejectedFilesError: null,
        previewClass: null,
        onDrag: false
      });
    }
  }

  dropRejected(rejectedFiles) {
    if (rejectedFiles.length > 0) {
      this.setState({
        rejectedFilesError: 'This file type is not accepted or is too large.',
        onDrag: false
      });
    }
  }

  removeImage() {
    const preview = this.state.preview;
    this.setState({
      preview: null,
      disabled: false,
      previewClass: null,
      onDrag: false
    });

    const { handleImageClear } = this.props;
    if (handleImageClear && typeof handleImageClear === 'function') {
      handleImageClear();
    }

    if (preview) {
      window.URL.revokeObjectURL(preview);
    }
  }

  previewLoaded(img) {
    if (img) {
      const targetRatio = 600 / 400;
      const ratio = img.height ? img.width / img.height : 0;
      this.setState({
        previewClass:
          ratio < targetRatio ? 'height-constrained' : 'width-constrained',
        onDrag: false
      });
    }
  }

  render() {
    const { preview, previewClass, rejectedFilesError, onDrag } = this.state;

    return (
      <div className="image-upload-container">
        {rejectedFilesError && (
          <Alert variant="danger">{rejectedFilesError}</Alert>
        )}
        <Dropzone
          disabledClassName="image-disabled"
          acceptClassName="image-accept"
          rejectClassName="image-rejected"
          onDrop={this.handleDrop}
          accept="image/jpeg,image/jpg,image/png,image/gif"
          disabled={this.state.disabled}
          multiple={false}
          onDropRejected={this.dropRejected}
          onDragEnter={() => this.setState({ onDrag: true })}
          onDragLeave={() => this.setState({ onDrag: false })}
          className="image-upload-dropzone"
        >
          <div
            className="image-upload-field"
            aria-label="Image upload drag and drop"
          >
            {!onDrag ? (
              <>
                <A11yFontIcon
                  className="upload-image-icon"
                  icon="plus"
                  fixed
                  size="2x"
                  alt="Upload a picture"
                />
                <div className="image-upload-text">Add Photo</div>
                <div>or drag and drop</div>
              </>
            ) : (
              <>
                <div className="image-upload-text accepted-text">
                  Drop file to upload
                </div>
                <div className="image-upload-text rejected-text">
                  The file is rejected
                </div>
              </>
            )}
          </div>
        </Dropzone>
        {preview && (
          <div className="image-preview" aria-label="Uploaded Image Preview">
            <img
              className={`image-source ${previewClass || ''}`}
              src={preview}
              onLoad={e => e && this.previewLoaded(e.target)}
              alt="Upload Preview"
            />
            <TextButton
              className="modal-close-button"
              onClick={this.removeImage}
            >
              {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
              <img src={ModalCloseIcon} alt="Remove Image" />
            </TextButton>
          </div>
        )}
      </div>
    );
  }
}

ImageUpload.propTypes = {
  handleImageDrop: PropTypes.func.isRequired,
  handleImageClear: PropTypes.func
};

export default ImageUpload;
